/**
 * La informacion que se envia al endpoint de radication
 *
 * @export
 * @class Radicacion
 */
export class Radicacion {
  idDocumento: number;
  radicado: string;
  fecha: Date;
  folios: number;
}

/**
 * Modelo de un acta unica del ministerio (AUCTIFF)
 *
 * @export
 * @class ActaAUCTIFF
 */
export class ActaAUCTIFF {
  idtalonario_acta: number;
  consecutivo: number;
  seleccionado: number;
  idconsecutivo_acta: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/radicacion.model.ts